
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 29","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.95.002h17.414C20.36.002 22 1.575 22 3.506v21.988c0 1.924-1.632 3.504-3.636 3.504H.95c-.52 0-.95-.408-.95-.915V.917c0-.5.423-.915.95-.915z","fill":"#0E6199"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.95.002h2.085v28.996H.95c-.52 0-.95-.408-.95-.915V.917c0-.5.423-.915.95-.915z","fill":"#014A7A"}}),_c('path',{attrs:{"d":"M18.335 8.633H7.31a.313.313 0 00-.319.308v1.15c0 .17.143.308.32.308h11.025a.313.313 0 00.32-.307V8.94a.313.313 0 00-.32-.308zM18.335 15.884H8.77c-.152 0-.275.137-.275.307v1.152c0 .17.123.307.275.307h9.564c.151 0 .274-.138.274-.307V16.19c0-.17-.123-.307-.274-.307zM18.386 12.552h-7.48c-.118 0-.215.137-.215.307v1.151c0 .17.097.308.216.308h7.479c.119 0 .215-.138.215-.308V12.86c0-.17-.096-.307-.215-.307z","fill":"#014A7A"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.521.002h3.428v6.629l-1.676-2.16-1.752 2.16V.002z","fill":"#F7CA03"}})])
          )
        }
      }
    